import React from "react";
import styled from "styled-components";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

/**
 * Renders both the `"error"` and `"failed"` UI states. Mirrors monolith
 * lines 1205–1226.
 */
export const ErrorState: React.FC<{
  kind: "error" | "failed";
  message: string;
  onRetry: () => void;
}> = ({ kind, message, onRetry }) => (
  <SignupMessage>
    <h3>{kind === "failed" ? "Generation Failed" : "Error"}</h3>
    <p>{message || "An error occurred."}</p>
    <button
      type="button"
      onClick={onRetry}
      style={{
        marginTop: "15px",
        padding: "8px 16px",
        background: "#444",
        color: "white",
        border: "none",
        cursor: "pointer",
        borderRadius: "4px",
      }}
    >
      Retry
    </button>
  </SignupMessage>
);

export default ErrorState;
